export default {
	EDIT_PROMO: '@@promoAndDiscountReducer/EDIT_PROMO',
	TICKET_TYPES_CHECKED: '@promoAndDiscountReducer/TICKET_TYPES_CHECKED',
	RESET: '@@promoAndDiscountReducer/RESET',
	LOAD_PROMO: '@@promoAndDiscountReducer/LOAD_PROMO'
}
